/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IActivityEventTypesData } from "Interfaces/SiteContent/IActivityEventTypesData";

import {
  ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD,
  ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD_FAILURE,
  ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD_SUCCESS,
} from "./ActivityEventTypesActionTypes";

/**
 *@interface
 */
export interface IGetActivityEventTypes {
  type: typeof ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD;
  tenant: string;
}

export interface IGetActivityEventTypesSuccess {
  type: typeof ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD_SUCCESS;
  activityEventTypes: IActivityEventTypesData[];
}

export interface IGetActivityEventTypesFailure {
  type: typeof ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD_FAILURE;
  activityEventTypesLoadError: string;
}

export const getActivityEventTypes = (tenant: string): ActivityEventTypesActionTypes => ({
  type: ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD,
  tenant: tenant,
});

export const getActivityEventTypesSuccess = (
  activityEventTypes: IActivityEventTypesData[]
): ActivityEventTypesActionTypes => ({
  type: ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD_SUCCESS,
  activityEventTypes,
});

export const getActivityEventTypesFailure = (
  activityEventTypesLoadError: string
): ActivityEventTypesActionTypes => ({
  type: ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD_FAILURE,
  activityEventTypesLoadError,
});

export type ActivityEventTypesActionTypes =
  | IGetActivityEventTypes
  | IGetActivityEventTypesSuccess
  | IGetActivityEventTypesFailure;
